import { useState, useRef, useEffect } from 'react';
import { Row, Col, Image, Button, Typography, Tabs, Skeleton } from 'antd';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { BASE_URL } from '../constants/Url';
import './ProductDetailPage.css'; // Custom styles
import TabPane from 'antd/es/tabs/TabPane';
import { useLocation, useNavigate, useParams } from 'react-router';
import _ from 'lodash';
import BackHome from './BackHome';
import RelatedProducts from './RelatedProducts';
import { useTranslation } from 'react-i18next';

const { Title, Paragraph, Text } = Typography;

const ProductDetailPage = () => {
    const sliderRef = useRef(null);
    const navigate = useNavigate();
    const [notFound, setNotFound] = useState(false);
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState({
        title: "",
        salePrice: "",
        originalPrice: "",
        image: [],
        code: "",
    });
    const [currentIndex, setCurrentIndex] = useState(0);
    const [hover, setHover] = useState(false); // 👈 add hover state
    const { code } = useParams();
    const location = useLocation();
    const { t } = useTranslation();

    useEffect(() => {
        const fetchData = () => {
            const param = { code: code };
            if (!_.isEmpty(location) && !_.isEmpty(location.state) && !_.isEmpty(location.state.shop)) {
                setData(location.state.shop);
            } else {
                setNotFound(true);
            }
        };
        fetchData();
    }, [location, code]);

    const product = {
        title: "Man’s Shirt long sleeve",
        price: 90,
        originalPrice: 95,
        description: [
            "Handwoven 100%",
            "Made from Silk",
            "Designed and weaved by expert women weavers who love her career and Cambodian pattern home fabric.",
            "It need 5 people to prepare and design pattern since the beginning and weaves by our weavers in order to finish within 5 days to one week.",
            "Recommend for Hand-wash with liquid soap or washing machine with hand-washable function.",
            "A handmade fabric that make you feel proud to use with a humble works from our women who working from home."
        ],
        images: [
            `${BASE_URL}/about-us/soeungKontoisKaneav.jpg`,
            `${BASE_URL}/about-us/soeungKontoisKaneav1.jpg`,
            `${BASE_URL}/about-us/soeungKontoisKaneav2.jpg`,
        ],
    };

    const NextArrow = ({ onClick }) => (
        <div
            className="custom-arrow next"
            onClick={onClick}
            style={{
                backgroundColor: "rgb(17, 152, 17)",
                display:
                    hover ? 'flex' : 'none', // 👈 show only if hover true
                alignItems: 'center',
                height: "40px",
                width: "40px",
                color: "white",
                borderRadius: "50%",
                justifyContent: 'center'
            }}
        >
            ▶
        </div>
    );

    const PrevArrow = ({ onClick }) => (
        <div
            className="custom-arrow prev"
            onClick={onClick}
            style={{
                backgroundColor: "rgb(17, 152, 17)",
                display:
                    hover ? 'flex' : 'none', // 👈 show only if hover true
                alignItems: 'center',
                height: "40px",
                width: "40px",
                color: "white",
                borderRadius: "50%",
                justifyContent: 'center'
            }}
        >
            ◀
        </div>
    );

    const sliderSettings = {
        dots: false,
        arrows: true,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 60000,
        beforeChange: (_, next) => setCurrentIndex(next),
    };

    const handleThumbnailClick = (index) => {
        setCurrentIndex(index);
        sliderRef.current?.slickGoTo(index);
    };


    // ⏳ setTimeout 1 minute (1000ms) to switch loading -> data
    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false); // 🔥 stop loading after 1min
        }, 1000);

        return () => clearTimeout(timer); // Cleanup if unmount
    }, []);
    const handleAddCard = (item) => {
        navigate(`/card`);
    }

    return (
        <>
            <BackHome title={t("Shop")} product={data?.title} link="/shop" sub={t("Shop" )}t={t}/>
            <div className="esi-white-space"></div>
            <div className="esi-std-container pb-5">
                <div className="p-6">
                    <Row gutter={32}>
                        {
                            loading ?
                                <div className="grid grid-cols-7 cursor-pointer select-none" style={{ marginBottom: "3rem" }}>
                                    <div className="col-span-3 overflow-hidden rounded-[0.5rem]">
                                        <Skeleton.Image rootClassName='esi-sub-news-card-image' style={{ cursor: "pointer" }} className='esi-sub-news-card-image' active={true} />
                                    </div>
                                    <div className='col-span-4 px-3 flex flex-col justify-between'>
                                        <div className='flex flex-col gap-1'>
                                            <Skeleton.Input className="esi-news-card-title max-w-[50%] line-clamp-2" active block />
                                            <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />
                                            <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />
                                            <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />
                                            <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />
                                            <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />
                                            <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />
                                            <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />
                                            <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />
                                            <Skeleton.Input className="esi-news-card-title max-w-[100%] line-clamp-2" active block />
                                            <Skeleton.Input
                                                rootClassName='max-sm:!hidden md:!block'
                                                className="esi-news-card-description max-w-[100%] line-clamp-2 sm:line-clamp-3" active block />
                                        </div>
                                    </div>
                                </div> :
                                <>
                                    <Col span={2} style={{ display: 'flex', flexDirection: 'column' }}>
                                        {data.image.map((img, index) => (
                                            <>
                                                <Image
                                                    key={index}
                                                    src={img}
                                                    width={60}
                                                    height={80}
                                                    preview={false}
                                                    onClick={() => handleThumbnailClick(index)}
                                                    style={{
                                                        marginBottom: "20px",
                                                        border: index === currentIndex ? '2px solid rgb(17, 152, 17)' : '1px solid #ccc',
                                                        borderRadius: 4,
                                                        cursor: 'pointer',
                                                    }}
                                                />
                                            </>
                                        ))}
                                    </Col>

                                    <Col
                                        span={10}
                                        style={{ position: 'relative' }}
                                        onMouseEnter={() => setHover(true)}
                                        onMouseLeave={() => setHover(false)}
                                    >
                                        <Slider ref={sliderRef} {...sliderSettings}>
                                            {data.image.map((img, index) => (
                                                <div key={index}>
                                                    <Image src={img} width="100%" height="420px" style={{ borderRadius: 8, objectFit: 'cover' }} />
                                                </div>
                                            ))}
                                        </Slider>
                                    </Col>
                                </>
                        }

                        <Col span={10}>
                            <Title level={3}>{data?.title}</Title>
                            {/* <div style={{ marginBottom: 12 }}>
                                <Text delete style={{ marginRight: 10 }}>$ {data?.originalPrice}</Text>
                                <Text strong style={{ fontSize: 20 }}>$ {data?.salePrice}</Text>
                            </div> */}
                            <div>
                                {product.description.map((line, idx) => (
                                    <Paragraph key={idx} style={{ marginBottom: 8 }}>
                                        – {line}
                                    </Paragraph>
                                ))}
                            </div>
                            {/* <Button onClick={() => handleAddCard()} type="primary" size="large" style={{ marginTop: 24, backgroundColor: "#119811", fontWeight: 800 }}>
                                ADD TO CART
                            </Button> */}
                        </Col>
                        <Tabs defaultActiveKey="1" className="mt-6 cusTab" style={{ color: "#119811" }}>
                            <TabPane tab="DESCRIPTION" key="1" style={{ color: "#119811" }}>
                                <Paragraph><strong>Description</strong></Paragraph>
                                {product.description.map((line, idx) => (
                                    <Paragraph key={idx}>– {line}</Paragraph>
                                ))}
                            </TabPane>
                            <TabPane tab="ADDITIONAL INFORMATION" key="2">
                                <Paragraph>Additional product details here...</Paragraph>
                            </TabPane>
                            <TabPane tab="REVIEWS (0)" key="3">
                                <Paragraph>No reviews yet.</Paragraph>
                            </TabPane>
                        </Tabs>
                    </Row>
                </div>
                {/* <RelatedProducts /> */}
                <div className="esi-white-space"></div>
            </div>
        </>
    );
};

export default ProductDetailPage;